import React, { Component } from 'react';
import { Text, View, StyleSheet, Image } from '../react-native';
import { withRouter } from 'react-router-dom'

class WelcomeScreen extends Component {
  componentDidMount() {
    setTimeout(() => this.props.history.push(('/Name')), 1500)
  }
  
  render() {
    const { containerStyle, titleStyle, logoStyle } = styles
    
    return (
      <View style={containerStyle}>
        <Text style={titleStyle}>
          Simple
        </Text>
        <Image style={logoStyle} source={{ uri: 'https://media1.tenor.com/images/db85ba00c6073b451a8f05156a66524e/tenor.gif' }}/>
        <Text style={titleStyle}>
          Loading...
        </Text>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  containerStyle: {
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#A2E4F9",
    height: '100vh'
  },
  titleStyle: {
    margin: 24,
    fontSize: 44,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#D34936',
  },
  logoStyle: {
    height: 128,
    width: 256,
  }
});
export default withRouter(WelcomeScreen)



// WEBPACK FOOTER //
// ./src/screens/WelcomeScreen.js